export const WISHLIST = {
    CREATE_WISHLIST_REQUEST : 'CREATE_WISHLIST_REQUEST',
    CREATE_WISHLIST_SUCCESS : 'CREATE_WISHLIST_SUCCESS',
    CREATE_WISHLIST_FAILURE : 'CREATE_WISHLIST_FAILURE',

    FETCH_WISHLIST_REQUEST : 'FETCH_WISHLIST_REQUEST',
    FETCH_WISHLIST_SUCCESS : 'FETCH_WISHLIST_SUCCESS',
    FETCH_WISHLIST_FAILURE : 'FETCH_WISHLIST_SUCCESS',

    DELETE_WISHLIST_REQUEST : 'DELETE_WISHLIST_REQUEST', 
    DELETE_WISHLIST_SUCCESS : 'DELETE_WISHLIST_SUCCESS',
    DELETE_WISHLIST_FAILURE : 'DELETE_WISHLIST_FAILURE'
}